import { Stack, useColorModeValue } from "@chakra-ui/react";
import { lazy, Suspense,useEffect,useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import LiveStreaming from "../pages/dashboard/liveStream/LiveStreaming";
import Streaming from "../pages/dashboard/stream/LiveStreaming";
import Meetings from "../pages/dashboard/Meetings";
import Messaging from "../pages/messaging/Messaging";
import Messaging11 from "../pages/messaging/Messaging11";
import GroupChat from "../pages/group/GroupChat";
import Profile from "../pages/dashboard/profile/Profile";
import SideSection from "../pages/dashboard/sideSection/SideSection";
import TopNav from "../pages/dashboard/topNav/TopNav";
import TradingGroup from "../pages/dashboard/tradingGroup/TradingGroup";
import {
  marginLeftForSmallDevice,
  sidebarPaddingLeftForSmallDevice,
  smallDeviceWidthSize,
} from "../constants";
import CreateGroup from "../pages/dashboard/CreateGroup";
import EditGroup from "../pages/dashboard/EditGroup";
import CustomStyleInjector from "./CustomStyleInjector";
import ProfileOverview from "./profile/ProfileOverview";
import LiveStreamNow from "../pages/dashboard/liveStream/LiveStreamNow";
import WatchStreamNow from "../pages/dashboard/stream/WatchStreamNow";
import MobileFloatNav from "./MobileFloatNav";
import useSmallScreen from "./useSmallScreen";
import Earning from "./profile/Earning";
import ProfileOverviewUser from "./profile/ProfileOverviewUser";
import MainEditor from "../pages/dashboard/discover/stories/MainEditor";
import { useDisclosure } from "@chakra-ui/hooks";
import { Collapse } from "@chakra-ui/transition";

function AuthenticatedRoutes() {
  const Discover = lazy(() => import("../pages/dashboard/discover/Discover"));
  const sidebarBg = useColorModeValue("#fff", "#020b19");
  const sidebarTextColor = useColorModeValue("#000", "#fff");
  const [view, setView] = useState(false)
     const { isOpen, onToggle } = useDisclosure({ defaultIsOpen: true });
  const sidebarBoxShadowColor = useColorModeValue("#dbdbdb", "#000");
  const [smallScreen] = useSmallScreen();
  return (
    <Suspense fallback={<p></p>}>
      <BrowserRouter>
        {" "}
        <CustomStyleInjector>
          <Stack direction={"row"} position="relative">
            {!smallScreen && (
              <Stack
                flex="1"
                alignItems={"center"}
                boxShadow={`1px 2px 3px 0px ${sidebarBoxShadowColor}`}
                borderRadius="2px"
                py="10px"
                pl={["0", "0", "0", "10px"]}
                bg={sidebarBg}
                color={sidebarTextColor}
                position={"fixed"}
                zIndex="1022"
                w={isOpen ? smallDeviceWidthSize : "70px"}
              >
                <SideSection isOpen={isOpen} onToggle={onToggle} />
              </Stack>
            )}
            <Stack
              flex="6"
              // border={"1px solid red"}
              p="10px"
              position={"relative"}
              ml={["unset", isOpen ? marginLeftForSmallDevice : "150px"]}
              overflow="hidden"
            >
              <TopNav isOpen={isOpen} />
              {/* <Stack mt="70px !important" pl={sidebarPaddingLeftForSmallDevice}> */}
              <Stack
                mt="70px !important"
                pl={isOpen ? sidebarPaddingLeftForSmallDevice : "70px"}
              >
                <Routes>
                  <Route path="/" element={<Discover />} />
                  <Route path="/dashboard" element={<Discover />} />
                  <Route path="/live-streaming" element={<LiveStreaming />} />
                  <Route path="/meetings" element={<Meetings />} />
                  <Route
                    path="/messaging/:privateUserId?"
                    element={<Messaging />}
                  />
                  <Route
                    path="/messaging11/:privateUserId?"
                    element={<Messaging11 />}
                  />
                  <Route path="/group/:id" element={<GroupChat />} />
                  <Route path="/group" element={<GroupChat />} />
                  <Route path="/profile" element={<Profile />} />
                  <Route path="/earnings" element={<Earning />} />
                  <Route
                    path="/view-profile/:id"
                    element={<ProfileOverviewUser />}
                  />
                  <Route path="/view-profile" element={<Profile />} />

                  <Route path="/groups" element={<TradingGroup />} />
                  <Route path="/create-group" element={<CreateGroup />} />
                  <Route path="/groups/:slug" element={<EditGroup />} />
                  <Route path="/view-live-stream" element={<LiveStreamNow />} />
                  <Route path="/view-stream" element={<WatchStreamNow />} />
                  <Route path="/image-editor" element={<MainEditor />} />
                  <Route path="/*" element={<Discover />} />
                  <Route
                    path="/view-profile"
                    element={<ProfileOverview editable={false} />}
                  />
                </Routes>
              </Stack>
              {smallScreen && <MobileFloatNav />}
            </Stack>
          </Stack>
        </CustomStyleInjector>
      </BrowserRouter>
    </Suspense>
  );
}

export default AuthenticatedRoutes;
